module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/atom-4b3c5056238cf247987605ec0acdd5f0.gif";